import {Component, Input} from '@angular/core';

export interface Link {
  label: string;
  url: string;
}

@Component({
  selector: 'app-link-panel',
  imports: [],
  templateUrl: './link-panel.html',
  styleUrl: './link-panel.scss'
})
export class LinkPanel {
  @Input() title: string = '';
  @Input() links: Link[] = [];
}
